// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","43":"test","443":"about","646":"introduce","781":"logo"}[chunkId] + "." + {"18":"babd8076","43":"c4c92344","443":"844eb5c9","646":"852bcb90","781":"7f6f77a6"}[chunkId] + ".js";
};